import { http } from '@/utils/http';
import Store from '@/store/index';

// 获取 redis 实例详情
export const reqFetchRedisInfo = (connToken) =>
  http.request({
    url: `/v1/redis/detail`,
    method: 'GET',
    params: connToken
  });

  // 执行 redis 功能
export const reqExec = (params) =>
  http.request({
    url: `/v1/redis/exec`,
    method: 'POST',
    data: params
});

// 获取 key 列表
export const reqFetchKeys = () =>
  http.request({
    url: `/redis/data/${Store.getters['source/calcId']}/keys`,
    method: 'GET'
  });

// 根据 key 查询详情
export const reqShowKey = key =>
  http.request({
    url: `/redis/data/${Store.getters['source/calcId']}/${key}`,
    method: 'GET',
    showError: false
  });

// 设置超时时间
export const reqSetTimeout = (key, timeOut) =>
  http.request({
    url: `/redis/data/set/timeout`,
    method: 'POST',
    data: {
      dataSourceId: Store.getters['source/calcId'],
      key,
      timeOut
    }
  });

// 重命名 key
export const reqRenameKey = (oldName, newName) =>
  http.request({
    url: `/redis/data/rename`,
    method: 'POST',
    data: {
      dataSourceId: Store.getters['source/calcId'],
      oldName,
      newName
    }
  });

// 删除 key
export const reqDestroyKey = keyName =>
  http.request({
    url: `/redis/data`,
    method: 'DELETE',
    data: {
      dataSourceId: Store.getters['source/calcId'],
      keyName
    }
  });

// 执行命令
export const reqExecuteCommand = command =>
  http.request({
    url: `/redis/command`,
    method: 'POST',
    data: {
      dataSourceId: Store.getters['source/calcId'],
      command
    },
    showError: false
  });
